import type { CustomerQueueVisibility } from './customerQueueVisibility';
import { normalizeCustomerQueueVisibility } from './customerQueueVisibility';

/**
 * Business-level flags for pickup-style visit copy and optional SMS when service is marked complete.
 * Stored on `businesses/{businessId}` (see AuthManager.saveBusinessOwner).
 */
export interface CustomerPickupBusinessPrefs {
  pickupReadyDisplayEnabled: boolean;
  pickupReadySmsEnabled: boolean;
}

/** Queue visibility + pickup prefs from one `businesses/{id}` read (customer appointment UI). */
export interface CustomerAppointmentBusinessPrefs extends CustomerPickupBusinessPrefs {
  customerQueueVisibility: CustomerQueueVisibility;
}

export const DEFAULT_CUSTOMER_PICKUP_PREFS: CustomerPickupBusinessPrefs = {
  pickupReadyDisplayEnabled: false,
  pickupReadySmsEnabled: false,
};

export function normalizePickupReadyDisplay(raw: unknown): boolean {
  return raw === true;
}

export function normalizePickupReadySms(raw: unknown): boolean {
  return raw === true;
}

export function parseCustomerPickupPrefs(data: Record<string, unknown> | null | undefined): CustomerPickupBusinessPrefs {
  if (!data) return { ...DEFAULT_CUSTOMER_PICKUP_PREFS };
  return {
    pickupReadyDisplayEnabled: normalizePickupReadyDisplay(data.pickupReadyDisplayEnabled),
    pickupReadySmsEnabled: normalizePickupReadySms(data.pickupReadySmsEnabled),
  };
}

export function parseCustomerAppointmentBusinessPrefs(
  data: Record<string, unknown> | null | undefined
): CustomerAppointmentBusinessPrefs {
  return {
    customerQueueVisibility: normalizeCustomerQueueVisibility(data?.customerQueueVisibility),
    ...parseCustomerPickupPrefs(data),
  };
}
